<template lang="pug">
  Sidebar

    div.d-flex.justify-content-end.align-items-center.custom-sidebar
      SidebarHeader.flex-fill
        template
          div.d-flex.justify-content-end
            div.p-1.align-self-center.flex-fill.text-left
              span {{ $store.getters.displayName }}
            b-link.align-self-center(to="/system/setting" v-b-tooltip.hover :title="$t('ui.settings')").mr-1
              i.p-1.fa.fa-sliders-h
            b-link.align-self-center(to="/logout" v-b-tooltip.hover :title="$t('ui.logout')")
              i.p-1.fa.fa-sign-out-alt
      SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
    SidebarNav(:navItems="navItems")
    //- SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
</template>

<script>
import config from "@/config";
import { Sidebar, SidebarHeader, SidebarNav, SidebarMinimizer } from "@/library/coreui";

export default {
  components: {
    Sidebar,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  computed: {
    navItems() {
      return [
        {
          name: this.$t("ui.configuration"),
          icon: "fa fa-cogs",
          pages: [config.accessRoles.host, config.accessRoles.provider, config.accessRoles.login, config.accessRoles.sbologin, config.accessRoles.ibclogin, config.accessRoles.cmdlogin,
                  config.accessRoles.bot, config.accessRoles.proxy, config.accessRoles.jobcontrol],
          children: [
            {
              name: this.$tc("ui.providers", 2),
              url: "/configuration/provider",
              icon: "fas fa-sitemap",
              pages: [config.accessRoles.provider]
            },
            {
              name: this.$tc("ui.hosts", 2),
              url: "/configuration/host",
              icon: "fa fa-h-square",
              pages: [config.accessRoles.host]
            },
            // {
            //   name: this.$tc("ui.login"),
            //   url: "/configuration/login",
            //   icon: "fas fa-sign-in-alt",
            //   pages: [config.accessRoles.login]
            // },
            {
              name: this.$t("ui.sbo_login"),
              url: "/configuration/sbologin",
              icon: "fas fa-sign-in-alt",
              pages: [config.accessRoles.sbologin]
            },
            {
              name: this.$t("ui.ibc_login"),
              url: "/configuration/ibclogin",
              icon: "fas fa-sign-in-alt",
              pages: [config.accessRoles.ibclogin]
            },
            // {
            //   name: this.$t("ui.cmd_login"),
            //   url: "/configuration/cmdlogin",
            //   icon: "fas fa-sign-in-alt",
            //   pages: [config.accessRoles.cmdlogin]
            // },
            {
              name: this.$tc("ui.proxies", 2),
              url: "/configuration/proxy",
              icon: "fas fa-server",
              pages: [config.accessRoles.proxy]
            },
            // {
            //   name: this.$tc("ui.bots", 1),
            //   url: "/configuration/bot",
            //   icon: "fas fa-robot",
            //   pages: [config.accessRoles.bot]
            // },
            {
              name: this.$t("ui.sbo_bot"),
              url: "/configuration/sbobot",
              icon: "fas fa-robot",
              pages: [config.accessRoles.sbobot]
            },
            {
              name: this.$tc("ui.ibc_bot"),
              url: "/configuration/ibcbot",
              icon: "fas fa-robot",
              pages: [config.accessRoles.ibcbot]
            },
            // {
            //   name: this.$tc("ui.cmd_bot"),
            //   url: "/configuration/cmdbot",
            //   icon: "fas fa-robot",
            //   pages: [config.accessRoles.cmdbot]
            // },
            {
              name: this.$t("ui.job_control"),
              url: "/configuration/jobcontrol",
              icon: "fas fa-tasks",
              pages: [config.accessRoles.jobcontrol]
            },
            {
              name: this.$t("ui.job_control_sport"),
              url: "/configuration/jobcontrolsport",
              icon: "fas fa-tasks",
              pages: [config.accessRoles.jobcontrolsport]
            },
            {
              name: this.$tc("ui.sports", 1),
              url: "/configuration/sport",
              icon: "fa fa-basketball-ball",
              pages: [config.accessRoles.sport]
            },
          ]
        },
        {
          name: this.$t("ui.monitor"),
          icon: "fa fa-eye",
          pages: [config.accessRoles.asidebar, config.accessRoles.omcache, config.accessRoles.sbomatch, config.accessRoles.ibcmatch],
          children: [
            {
              name: this.$tc("ui.status"),
              url: "/monitor/status",
              icon: "fas fa-signal",
              pages: [config.accessRoles.status]
            },
            {
              name: this.$tc("ui.account"),
              url: "/monitor/statusaccount",
              icon: "fas fa-signal",
              pages: [config.accessRoles.status]
            },
            {
              name: this.$tc("ui.omcache"),
              url: "/monitor/omcache",
              icon: "fa fa-microchip",
              pages: [config.accessRoles.omcache]
            },
            {
              name: this.$t("ui.sbo"),
              url: "/monitor/sbomatch",
              icon: "fas fa-futbol",
              pages: [config.accessRoles.sbomatch]
            },
            {
              name: this.$t("ui.ibc"),
              url: "/monitor/ibcmatch",
              icon: "fas fa-futbol",
              pages: [config.accessRoles.ibcmatch]
            },
            // {
            //   name: this.$t("ui.cmd"),
            //   url: "/monitor/cmdmatch",
            //   icon: "fas fa-futbol",
            //   pages: [config.accessRoles.cmdmatch]
            // }
          ]
        },
        {
          name: this.$tc("ui.leagues", 1),
          icon: "fas fa-trophy",
          pages: [config.accessRoles.league, config.accessRoles.mapleague, config.accessRoles.remapleague],
          children: [
            {
              name: this.$tc("ui.leagues", 2),
              url: "/league/league",
              icon: "fas fa-trophy",
              pages: [config.accessRoles.league]
            },
            {
              name: this.$t("ui.map_league"),
              url: "/league/mapleague",
              icon: "fas fa-link",
              pages: [config.accessRoles.mapleague]
            },
            // {
            //   name: this.$t("ui.remap_league"),
            //   url: "/league/remapleague",
            //   icon: "fas fa-link",
            //   pages: [config.accessRoles.remapleague]
            // }
            {
              name: this.$t("ui.purge_league"),
              url: "/league/purgeleague",
              icon: "fa fa-trash",
              pages: [config.accessRoles.purgeleague]
            },
            {
              name: this.$t("ui.purge_ibc_league"),
              url: "/league/purgeibcleague",
              icon: "fa fa-trash",
              pages: [config.accessRoles.purgeibcleague]
            },
            {
              name: this.$t("ui.purge_sbo_league"),
              url: "/league/purgesboleague",
              icon: "fa fa-trash",
              pages: [config.accessRoles.purgesboleague]
            }
          ]
        },
        {
          name: this.$tc("ui.teams", 1),
          icon: "fas fa-users",
          pages: [config.accessRoles.team, config.accessRoles.mapteam],
          children: [
            {
              name: this.$tc("ui.teams", 2),
              url: "/team/team",
              icon: "fas fa-users",
              pages: [config.accessRoles.team]
            },
            {
              name: this.$t("ui.map_team"),
              url: "/team/mapteam",
              icon: "fas fa-link",
              pages: [config.accessRoles.mapteam]
            },
            // {
            //   name: this.$t("ui.remap_team"),
            //   url: "/team/remapteam",
            //   icon: "fas fa-link",
            //   pages: [config.accessRoles.remapteam]
            // }
            {
              name: this.$t("ui.purge_team"),
              url: "/team/purgeteam",
              icon: "fa fa-trash",
              pages: [config.accessRoles.purgeteam]
            },
            {
              name: this.$t("ui.purge_ibc_team"),
              url: "/team/purgeibcteam",
              icon: "fa fa-trash",
              pages: [config.accessRoles.purgeibcteam]
            },
            {
              name: this.$t("ui.purge_sbo_team"),
              url: "/team/purgesboteam",
              icon: "fa fa-trash",
              pages: [config.accessRoles.purgesboteam]
            }
          ]
        },
        {
          name: this.$t("ui.match"),
          icon: "fas fa-gamepad",
          pages: [config.accessRoles.linkedmatch, config.accessRoles.mapmatch],
          children: [
            {
              name: this.$tc("ui.matches", 2),
              url: "/match/match",
              icon: "fas fa-gamepad",
              pages: [config.accessRoles.linkedmatch]
            },
            {
              name: this.$t("ui.map_match"),
              url: "/match/mapmatch",
              icon: "fas fa-link",
              pages: [config.accessRoles.mapmatch]
            },
            {
              name: this.$t("ui.map_match_other_sport"),
              url: "/match/mapmatchothers",
              icon: "fas fa-link",
              pages: [config.accessRoles.mapmatchothers]
            },
            // {
            //   name: this.$t("ui.remap_match"),
            //   url: "/match/remapmatch",
            //   icon: "fas fa-link",
            //   pages: [config.accessRoles.remapmatch]
            // },
            {
              name: this.$t("ui.map_outright"),
              url: "/match/mapoutright",
              icon: "fas fa-link",
              pages: [config.accessRoles.mapoutright]
            },
            {
              name: this.$t("ui.unmap_list"),
              url: "/match/unmapmatch",
              icon: "fas fa-unlink",
              pages: [config.accessRoles.unmapmatch]
            },
            // {
            //   name: this.$t("ui.change_date"),
            //   url: "/match/updatemapping",
            //   icon: "fa fa-link",
            //   pages: [config.accessRoles.updatemapping]
            // },
            {
              name: this.$t("ui.pre_add_match"),
              url: "/match/preaddmatch",
              icon: "fas fa-plus",
              pages: [config.accessRoles.preaddmatch]
            },
            {
              name: this.$t("ui.pre_add_match_cmd"),
              url: "/match/preaddmatchcmd",
              icon: "fas fa-plus",
              pages: [config.accessRoles.preaddmatch]
            },
            {
              name: this.$t("ui.pre_add_match_pending"),
              url: "/match/preaddmatchpending",
              icon: "fa fa-tasks",
              pages: [config.accessRoles.preaddmatch]
            },
            // {
            //   name: this.$t("ui.pre_add_match_ibet"),
            //   url: "/match/preaddmatchibet",
            //   icon: "fas fa-plus",
            //   pages: [config.accessRoles.preaddmatch]
            // },
            {
              name: this.$t("ui.purge_match"),
              url: "/match/purgematch",
              icon: "fa fa-trash",
              pages: [config.accessRoles.purgematch]
            },
            {
              name: this.$t("ui.match_clear_rs_rt"),
              url: "/match/matchclearrs",
              icon: "fas fa-eraser",
              pages: [config.accessRoles.matchclearrs]
            },
            {
              name: this.$t("ui.rs_rt_control"),
              url: "/match/rsrtcontrol",
              icon: "fas fa-tasks",
              pages: [config.accessRoles.rsrtcontrol]
            },
            {
              name: this.$t("ui.cmd_sbo_mapping"),
              url: "/match/cmdsbomapmatch",
              icon: "fas fa-link",
              pages: [config.accessRoles.cmdsbomapmatch]
            },
            {
              name: this.$t("ui.cmd_sbo_switching"),
              url: "/match/cmdsbomatch",
              icon: "fas fa-futbol",
              pages: [config.accessRoles.cmdsbomatch]
            },
            {
              name: this.$t("ui.outright_double_match"),
              url: "/match/outrightdoublematch",
              icon: "fas fa-futbol",
              pages: [config.accessRoles.outrightdoublematch]
            },
            // {
            //   name: this.$t("ui.ibc_ibt_mapping"),
            //   url: "/match/ibcibtmapmatch",
            //   icon: "fas fa-link",
            //   pages: [config.accessRoles.ibcibtmapmatch]
            // },
            // {
            //   name: this.$t("ui.ibc_ibt_switching"),
            //   url: "/match/ibcibtmatch",
            //   icon: "fas fa-futbol",
            //   pages: [config.accessRoles.ibcibtmatch]
            // }
          ]
        },
        {
          name: this.$t("ui.running_ball"),
          icon: "fas fa-running",
          pages: [config.accessRoles.dangerzone, config.accessRoles.rtfcommentary, config.accessRoles.matchfeed],
          children: [
            {
              name: this.$t("ui.rtf_commentary"),
              url: "/rb/rtfcommentary",
              icon: "fas fa-comment",
              pages: [config.accessRoles.rtfcommentary]
            },
            {
              name: this.$t("ui.danger_zone"),
              url: "/rb/dangerzone",
              icon: "fas fa-exclamation-triangle",
              pages: [config.accessRoles.dangerzone]
            },
            {
              name: this.$t("ui.danger_zone_corner"),
              url: "/rb/dangerzonecorner",
              icon: "fas fa-exclamation-triangle",
              pages: [config.accessRoles.dangerzone]
            },
            {
              name: this.$t("ui.danger_zone_booking"),
              url: "/rb/dangerzonebooking",
              icon: "fas fa-exclamation-triangle",
              pages: [config.accessRoles.dangerzone]
            },
            {
              name: this.$t("ui.danger_zone_goal_kick"),
              url: "/rb/dangerzonegoalkick",
              icon: "fas fa-exclamation-triangle",
              pages: [config.accessRoles.dangerzone]
            },
            {
              name: this.$t("ui.match_feed"),
              url: "/rb/matchfeed",
              icon: "fas fa-rss",
              pages: [config.accessRoles.matchfeed]
            },
            {
              name: this.$t("ui.rb_data"),
              url: "/rb/rbdata",
              icon: "fas fa-list",
              pages: [config.accessRoles.rbdata]
            },
            // {
            //   name: this.$t("ui.rb_data_detail"),
            //   url: "/rb/rbdata2",
            //   icon: "fas fa-list",
            //   pages: [config.accessRoles.rbdata]
            // },
            // {
            //   name: this.$t("ui.repull_data_detail"),
            //   url: "/rb/repulldata",
            //   icon: "fas fa-list",
            //   pages: [config.accessRoles.rbdata]
            // },
            // {
            //   name: this.$t("ui.match_feed"),
            //   url: "/rb/matchfeedOld",
            //   icon: "fas fa-rss",
            //   pages: [config.accessRoles.matchfeed]
            // },
            // {
            //   name: this.$t("ui.match_feed_2"),
            //   url: "/rb/matchfeed2",
            //   icon: "fas fa-rss",
            //   pages: [config.accessRoles.matchfeed]
            // }
          ]
        },
        {
          divider: true
        },
        {
          name: this.$t("ui.system"),
          icon: "fa fa-desktop",
          pages: [config.accessRoles.function, config.accessRoles.page, config.accessRoles.role, config.accessRoles.user],
          children: [
            {
              name: this.$tc("ui.functions", 2),
              url: "/system/function",
              icon: "fas fa-cube",
              pages: [config.accessRoles.function]
            },
            {
              name: this.$tc("ui.pages", 2),
              url: "/system/page",
              icon: "far fa-file",
              pages: [config.accessRoles.page]
            },
            {
              name: this.$tc("ui.roles", 2),
              url: "/system/role",
              icon: "fa fa-id-card",
              pages: [config.accessRoles.role]
            },
            {
              name: this.$tc("ui.users", 2),
              url: "/system/user",
              icon: "fa fa-users-cog",
              pages: [config.accessRoles.user]
            },
            {
              name: this.$t("ui.ip"),
              url: "/system/ip",
              icon: "fa fa-map-marker",
              pages: [config.accessRoles.ip]
            },
          ]
        },
        {
          name: this.$t("ui.configuration_logs"),
          icon: "fa fa-file",
          pages: [config.accessRoles.teamlog],
          children: [
            {
              name: this.$t("ui.provider_log"),
              url: "/log/providerlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.providerlog]
            },
            {
              name: this.$t("ui.host_log"),
              url: "/log/hostlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.hostlog]
            },
            {
              name: this.$t("ui.login_log"),
              url: "/log/loginlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.loginlog]
            },
            {
              name: this.$t("ui.proxy_log"),
              url: "/log/proxylog",
              icon: "fa fa-history",
              pages: [config.accessRoles.proxylog]
            },
            {
              name: this.$t("ui.bot_log"),
              url: "/log/botlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.botlog]
            },
            {
              name: this.$t("ui.job_control_log"),
              url: "/log/jobcontrollog",
              icon: "fa fa-history",
              pages: [config.accessRoles.jobcontrollog]
            },
            {
              name: this.$t("ui.sport_log"),
              url: "/log/sportlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.sportlog]
            }
          ]
        },
        {
          name: this.$t("ui.monitor_logs"),
          icon: "fa fa-file",
          pages: [config.accessRoles.teamlog],
          children: [
            {
              name: this.$t("ui.purge_sbo_match_log"),
              url: "/log/purgesbomatchlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.purgesbomatchlog]
            },
            {
              name: this.$t("ui.purge_ibc_match_log"),
              url: "/log/purgeibcmatchlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.purgeibcmatchlog]
            },
          ]
        },
        {
          name: this.$t("ui.league_logs"),
          icon: "fa fa-file",
          pages: [config.accessRoles.leaguelog],
          children: [
            {
              name: this.$t("ui.league_log"),
              url: "/log/leaguelog",
              icon: "fa fa-history",
              pages: [config.accessRoles.leaguelog]
            },
            {
              name: this.$t("ui.map_league_log"),
              url: "/log/mapleaguelog",
              icon: "fa fa-history",
              pages: [config.accessRoles.mapleaguelog]
            },
            {
              name: this.$t("ui.purge_league_log"),
              url: "/log/purgeleaguelog",
              icon: "fa fa-history",
              pages: [config.accessRoles.purgeleaguelog]
            },
          ]
        },
        {
          name: this.$t("ui.team_logs"),
          icon: "fa fa-file",
          pages: [config.accessRoles.teamlog],
          children: [
            {
              name: this.$t("ui.team_log"),
              url: "/log/teamlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.teamlog]
            },
            {
              name: this.$t("ui.map_team_log"),
              url: "/log/mapteamlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.mapteamlog]
            },
            {
              name: this.$t("ui.purge_team_log"),
              url: "/log/purgeteamlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.purgeteamlog]
            },
          ]
        },
        {
          name: this.$t("ui.match_log"),
          icon: "fa fa-file",
          pages: [config.accessRoles.actionlog],
          children: [
            // {
            //   name: this.$t("ui.action_log"),
            //   url: "/log/actionlog",
            //   icon: "fa fa-history",
            //   pages: [config.accessRoles.actionlog]
            // },
            {
              name: this.$t("ui.match_log"),
              url: "/log/matchlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.matchlog]
            },
            {
              name: this.$t("ui.map_match_log"),
              url: "/log/mapmatchlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.mapmatchlog]
            },
            {
              name: this.$t("ui.pre_add_match_log"),
              url: "/log/preaddmatchlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.preaddmatchlog]
            },
            {
              name: this.$t("ui.purge_match_log"),
              url: "/log/purgematchlog",
              icon: "fa fa-history",
              pages: [config.accessRoles.purgematchlog]
            },
          ]
        },
        {
          name: this.$t("ui.efight_logs"),
          icon: "fa fa-file",
          pages: [config.accessRoles.actionlog],
          children: [
            {
              name: this.$t("ui.efight_api_log"),
              url: "/log/efightapilog",
              icon: "fa fa-history",
              pages: [config.accessRoles.efightapilog]
            }
          ]
        },
      ];
    }
  },
  methods: {
    handleMinimized(e) {
      this.$store.dispatch("layout/setSidebarMinimized", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-sidebar {
  background: rgba(0, 0, 0, 0.4);
  -webkit-box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
  .sidebar-header {
    background: transparent;
    box-shadow: none;
  }
}
</style>
